export const TEAM_GRADIENTS: Record<string, readonly string[]> = {
  ARG: ['#75AADB', '#FFFFFF', '#75AADB'],
  BRA: ['#009C3B', '#FFDF00'],
  COL: ['#FFCD00', '#003893', '#CE1126'],
  ECU: ['#FFDD00', '#034EA2', '#ED1C24'],
  PAR: ['#D52B1E', '#FFFFFF', '#0038A8'],
  URU: ['#0038A8', '#FFFFFF'],
  GER: ['#000000', '#DD0000', '#FFCE00'],
  AUT: ['#ED2939', '#FFFFFF'],
  BEL: ['#000000', '#FAE042', '#ED2939'],
  BIH: ['#002395', '#FECB00'],
  CRO: ['#FF0000', '#FFFFFF', '#171796'],
  SCO: ['#0065BD', '#FFFFFF'],
  ESP: ['#AA151B', '#F1BF00'],
  FRA: ['#0055A4', '#FFFFFF', '#EF4135'],
  NED: ['#AE1C28', '#FFFFFF', '#21468B'],
  ENG: ['#FFFFFF', '#CE1124'],
  NOR: ['#BA0C2F', '#FFFFFF', '#00205B'],
  POR: ['#006600', '#FF0000'],
  CZE: ['#FFFFFF', '#D7141A', '#11457E'],
  SWE: ['#006AA7', '#FECC00'],
  SUI: ['#D52B1E', '#FFFFFF'],
  TUR: ['#E30A17', '#FFFFFF'],
  CAN: ['#FF0000', '#FFFFFF', '#FF0000'],
  CUW: ['#002B7F', '#F9E814', '#002B7F'],
  USA: ['#B22234', '#FFFFFF', '#3C3B6E'],
  HAI: ['#00209F', '#D21034'],
  MEX: ['#006847', '#FFFFFF', '#CE1126'],
  PAN: ['#005AA7', '#FFFFFF', '#D21034'],
  RSA: ['#007A4D', '#FFB81C', '#DE3831'],
  ALG: ['#006233', '#FFFFFF', '#D21034'],
  CPV: ['#003893', '#FFFFFF', '#CF2027'],
  CIV: ['#FF8200', '#FFFFFF', '#009E60'],
  EGY: ['#CE1126', '#FFFFFF', '#000000'],
  GHA: ['#006B3F', '#FCD116', '#CE1126'],
  MAR: ['#C1272D', '#006233'],
  COD: ['#007FFF', '#F7D618', '#CE1021'],
  SEN: ['#00853F', '#FDEF42', '#E31B23'],
  TUN: ['#E70013', '#FFFFFF'],
  KSA: ['#006C35', '#FFFFFF'],
  AUS: ['#00008B', '#FF0000', '#FFFFFF'],
  QAT: ['#8D1B3D', '#FFFFFF'],
  KOR: ['#FFFFFF', '#003478', '#C60C30'],
  IRN: ['#239F40', '#FFFFFF', '#DA0000'],
  IRQ: ['#CE1126', '#FFFFFF', '#007A3D'],
  JPN: ['#FFFFFF', '#BC002D'],
  JOR: ['#000000', '#FFFFFF', '#007A3D', '#CE1126'],
  UZB: ['#1EB53A', '#FFFFFF', '#0099B5'],
  NZL: ['#00247D', '#FFFFFF', '#CC142B'],
  FWC: ['#C9A227', '#F1C40F'],
  FWC_COPA:  ['#C9A227', '#F1C40F'],
  FWC_BOLAS: ['#1B5E20', '#C9A227'],
  FWC_HIST:  ['#5A1119', '#C9A227'],
  EXTRAS:    ['#6B21A8', '#F1C40F'],
  CC:  ['#8A1F2A', '#5A1119'],
};

export function getTeamGradient(code: string): string {
  const stops = TEAM_GRADIENTS[code] ?? ['#1B5E20', '#F1C40F'];
  return `linear-gradient(90deg, ${stops.join(', ')})`;
}

export function getTeamGradientDiagonal(code: string): string {
  const stops = TEAM_GRADIENTS[code] ?? ['#1B5E20', '#F1C40F'];
  return `linear-gradient(135deg, ${stops.join(', ')})`;
}
